import { environment } from 'src/environments/environment';

/** Ask the portal page that frames this app to open portal login. No-op outside that frame. */
export function requestPortalProductLogin(): boolean {
  let framed = false;
  try {
    framed = window.parent !== window;
  } catch {
    framed = true;
  }
  if (!framed) return false;

  let target = '';
  try {
    if (document.referrer) target = new URL(document.referrer).origin;
  } catch {
    target = '';
  }
  if (!target) {
    try {
      target = new URL(environment.portal_url).origin;
    } catch {
      target = '';
    }
  }
  if (!target) return false;
  window.parent.postMessage({ type: 'pulse-portal-login' }, target);
  return true;
}
